import { render, staticRenderFns } from "./NoRecords.vue?vue&type=template&id=6f7730c8&"
import script from "./NoRecords.vue?vue&type=script&lang=js&"
export * from "./NoRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports